export default "__VITE_ASSET__cxa9IjX$__"